import React from "react";

export default function Loader({ isLoading }) {
    if (!isLoading) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-4">
                <div className="relative">
                    <svg
                        className="animate-spin h-16 w-16 text-white"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        ></circle>
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8 8 8 0 01-8-8z"
                        ></path>
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <div className="h-6 w-6 bg-[#A31D1C] rounded-full animate-pulse"></div>
                    </div>
                </div>
                <p className="text-white text-lg font-bold animate-pulse">
                    Loading...
                </p>
            </div>
        </div>
    );
}